import {
  type MinMaxValue,
  type VehicleDetails,
  mileageUnitSchema,
} from './queries/schema/SharedSchema';

import {
  formatNumber,
  carValuationPriceFormatter,
} from '../../../../../helpers/formatting';
import { plural } from '@dist-marketplace-frontend/utils';

const formatVehicleDetails = (vehicleDetails: VehicleDetails) => {
  const {
    registrationNumber,
    mileage,
    mileageUnit,
    engineCapacityInCc,
    fuelType,
    transmission,
    colour,
    noOfOwners,
  } = vehicleDetails;

  const formattedMileage = `${formatNumber(mileage)} ${
    mileageUnit === mileageUnitSchema.enum.Kilometres ? 'km' : 'mi'
  }`;
  const formattedEngine = `${(engineCapacityInCc / 1000).toFixed(
    1,
  )} ${fuelType}`;
  const formattedNumberOfPreviousOwners = `${noOfOwners} Previous owner${plural(
    '',
    's',
    noOfOwners,
  )}`;

  return [
    registrationNumber,
    formattedMileage,
    formattedEngine,
    transmission,
    colour,
    formattedNumberOfPreviousOwners,
  ];
};

const formatValuation = (valuation: MinMaxValue) => {
  const format = carValuationPriceFormatter.format;
  return `${format(valuation.min)} - ${format(valuation.max)} `;
};

export { formatVehicleDetails, formatValuation };
